import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SharedModule } from 'src/shared';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { SupportVideoThumbnailComponent } from './support-video-thumbnail/support-video-thumbnail.component';
import { SupportVideoThumbnailsComponent } from './support-video-thumbnails/support-video-thumbnails.component';
import { RelatedVideosSpotController } from './related-videos-spot/related-videos-spot.controller';
import { VideoSectionSpotController } from './video-section-spot/video-section-spot.controller';
import { VideoSpotController } from './video-spot/video-spot.controller';
import { SupportVideoDirective } from './directives/support-video.directive';
import { VideoService } from './services/video.service';
import { SupportDesignModule } from 'src/Foundation/Design/app';
var moduleId = 'gn.audio.support.videos';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('RelatedVideosSpotController', RelatedVideosSpotController)
    .controller('VideoSectionSpotController', VideoSectionSpotController)
    .controller('VideoSpotController', VideoSpotController);
var VideosModule = (function () {
    function VideosModule() {
    }
    VideosModule = __decorate([
        NgModule({
            declarations: [
                AccordionItemComponent,
                SupportVideoThumbnailComponent,
                SupportVideoThumbnailsComponent,
                SupportVideoDirective,
            ],
            id: moduleId,
            imports: [SupportDesignModule, legacyModuleId, SharedModule],
            providers: [VideoService],
        })
    ], VideosModule);
    return VideosModule;
}());
export { VideosModule };
